(function($) {
    var openPhotoSwipe = function(url) {
      $.get(url, {},
        function(response){
          var pswpElement = document.querySelectorAll('.pswp')[0];

          // build items array
          var items = $.parseJSON(response);

          var thumbsHTML = '<ul class="list">';
          $.each(items, function(key, item) {
            thumbsHTML += '<li'+(key==0?' class="active"':'')+'>';
            thumbsHTML += '<div class="img" style="background-image: url(\''+item.thumb+'\');"></div>';
            thumbsHTML += '</li>';
          })
          thumbsHTML += '</ul>';
          $('.pswp__thumbs').html(thumbsHTML).show();
          $('.pswp__button--thumbs').show();

          // define options (if needed)
          var options = {
            // history & focus options are disabled on CodePen
            history: false,
            focus: false,
            shareEl: false,

            showAnimationDuration: 0,
            hideAnimationDuration: 0,
          };

          var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
          $('body').addClass('pswp__thumbs--open');
          gallery.init();
          $(document).on('click', '.pswp__thumbs .img', function(event) {
            gallery.goTo($(".pswp__thumbs li").index($(this).parent()));
          }).on('click', '.pswp__button--thumbs', function(event) {
            $('body').toggleClass('pswp__thumbs--open');
            gallery.applyZoomPan(gallery.getZoomLevel(), ($(gallery.container).width()-gallery.currItem.w*gallery.getZoomLevel())/2 , ($(gallery.container).height()-gallery.currItem.h*gallery.getZoomLevel())/2);
            gallery.updateSize(true);
            return false
          });
          gallery.listen('close', function () {
            $('body').removeClass('pswp__thumbs--open');
          });
          gallery.listen('afterChange', function() {
            var ind = gallery.getCurrentIndex();
            $('.pswp__thumbs li').eq(ind).addClass('active');
            $('.pswp__thumbs li').eq(ind).siblings().removeClass('active');
          });
        }
      ).fail(function(response) {
        console.log(response);
      });
    };
    $('.project-sect').on('click', '.open-detail', function(event) {
      openPhotoSwipe($(this).attr('href'))
      return false;
    });
})($);